<template lang="pug">
.radio
  input.radio__input(
    type="radio"
    :id="id"
    :value="value"
    :required="required"
    :disabled="disabled"
    :checked="shouldBeChecked"
    @change="updateInput"
  )
  label.radio__label(
    v-if="label"
    :for="id"
  ) {{ label }}
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change',
  },

  props: {
    value: {
      type: [Number, String],
      required: true,
    },

    label: {
      type: String,
      default: '',
    },

    id: {
      type: String,
      default: '',
    },

    modelValue: {
      type: [Number, String],
      default: '',
    },

    required: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    shouldBeChecked() {
      return this.modelValue == this.value;
    }
  },

  methods: {
    updateInput() {
      this.$emit('change', this.value);
    },
  },
};
</script>

<style lang="stylus" scoped>
.radio
  &__input
    display none

    &:checked + .radio__label:after
      width 8px
      height 8px
      top 6px
      left 5px
      background #6e6bce

  &__label
    font-size 14px
    padding-left 26px
    cursor pointer
    position relative

    &::before,
    &::after
      content ''
      border-radius 50%
      position absolute

    &::before
      width 16px
      height 16px
      background #FFF
      border solid 1px #cfd4d8
      box-shadow inset 2px 2px 8px rgba(0, 0, 0, .1)
      top 1px
      left 0
</style>



// WEBPACK FOOTER //
// Radio.vue?728beeea